<!-- eslint-disable vue/no-v-html -->
<template>
  <form
    ref="VisitorForm"
    class="visitor-step-1 visitor-step-1-theme"
    @submit.prevent="onSubmit"
  >
    <div
      ref="scrollDiv"
      class="visitor-step-1-inner"
    >
      <div class="visitor-step-1-login">
        <a @click="login">
          {{ $t('visitorLogin') }}
        </a>
      </div>
      <div class="visitor-step-1-header">
        <span
          class="visitor-step-1-header-text"
          v-html="visitorWelcomeText"
        />
        <img
          class="visitor-step-1-header-img"
          :src="visitorImage"
          alt="hand-image"
        >
      </div>
      <p class="visitor-step-1-desc">
        {{ $t('visitorLeaveDataReason') }}
      </p>
      <div class="visitor-label-wrapper">
        <label class="visitor-label">
          <input-index
            class="visitor-input"
            type="text"
            :value="visitorForm.input.name.value"
            :placeholder="$t('name') + '*'"
            @input="visitorForm.input.name.value = $event"
          />
        </label>
        <span
          v-if="hasFormSubmitted"
          v-show="formError.nameRequired"
          class="visitor-input-error"
        >
          {{ $t('TheFieldIsRequired') }}
        </span>
        <div class="visitor-label-blank" />
        <label class="visitor-label">
          <input-index
            class="visitor-input"
            type="email"
            :value="visitorForm.input.email.value"
            :placeholder="$t('email') + '*'"
            @input="visitorForm.input.email.value = $event"
          />
        </label>
        <span
          v-if="hasFormSubmitted"
          v-show="formError.emailRequired || formError.emailFormatInvalid"
          class="visitor-input-error"
        >
          {{
            formError.emailRequired
              ? $t('TheFieldIsRequired')
              : formError.emailFormatInvalid
                ? $t('IncorrectFormat')
                : ''
          }}
        </span>
        <div class="visitor-label-blank" />
        <label class="visitor-label">
          <input-index
            class="visitor-input"
            type="password"
            :value="visitorForm.input.password.value"
            :placeholder="$t('general.password') + '*'"
            autocomplete="new-password"
            @input="visitorForm.input.password.value = $event"
          />
        </label>
        <span
          v-if="hasFormSubmitted"
          v-show="formError.passwordRequired || formError.passwordFormatInvalid"
          class="visitor-input-error"
        >
          {{
            formError.passwordRequired
              ? $t('TheFieldIsRequired')
              : formError.passwordFormatInvalid
                ? $t('general.minLength', { n: 6 })
                : ''
          }}
        </span>
        <div class="visitor-label-blank" />
        <label class="visitor-label">
          <input-index
            class="visitor-input"
            type="text"
            :value="visitorForm.input.phone.value"
            :placeholder="$t('phone') + '*'"
            @input="visitorForm.input.phone.value = $event"
          />
        </label>
        <span
          v-if="hasFormSubmitted"
          v-show="formError.phoneRequired || formError.phoneFormatInvalid"
          class="visitor-input-error"
        >
          {{
            formError.phoneRequired
              ? $t('TheFieldIsRequired')
              : formError.phoneFormatInvalid
                ? $t('IncorrectFormat')
                : ''
          }}
        </span>
        <div class="visitor-label-blank" />
        <label class="visitor-label">
          <input-index
            class="visitor-input"
            type="text"
            :value="visitorForm.input.occupation.value"
            :placeholder="$t('occupation')"
            @input="visitorForm.input.occupation.value = $event"
          />
        </label>
        <div class="visitor-label-blank" />
      </div>
      <div class="visitor-checkbox-wrapper">
        <div>
          <Checkbox
            class="visitor-checkbox"
            :value="visitorForm.checkbox.agreement.value"
            @change="visitorForm.checkbox.agreement.value = $event"
          >
            <span
              class="agreement-text"
              v-html="visitorAgreement1"
            />
          </Checkbox>
        </div>
        <div>
          <Checkbox
            class="visitor-checkbox"
            :value="visitorForm.checkbox.agreePolicy.value"
            @change="visitorForm.checkbox.agreePolicy.value = $event"
          >
            <span
              class="agreement-text"
              v-html="visitorAgreement2"
            />
          </Checkbox>
        </div>
        <div
          v-if="hasFormSubmitted"
          v-show="formError.agreeLicenseRequired"
          class="visitor-input-error-wrapper"
        >
          <i class="isif isif-warn visitor-input-error-icon" />
          <span class="visitor-input-error">
            {{ $t('YouMustAgreeLicense') }}
          </span>
        </div>
      </div>
    </div>
    <div class="visitor-step-1-btn-wrapper">
      <span
        v-if="error"
        class="visitor-input-error"
      >
        {{ error }}
      </span>
      <button
        type="submit"
        class="visitor-step-1-btn"
        :disabled="busy"
      >
        {{ $t('Submit') }}
      </button>
    </div>
  </form>
</template>

<script>
import validate from 'validate.js'
import { mapActions, mapGetters } from 'vuex'
import gaEvents from '@/api/ga-events'
import { isIE } from '@/api/utils'
import Checkbox from '../../Checkbox/Checkbox'
import InputIndex from '../../Input'
import visitorApi from '@/services/api/visitor'
import handWithAnimateImage from './img/visitor-step1.svg'
import handImage from './img/visitor-step1-ie.svg'
import { MODALS } from '@/components/VrLounge'

export default {
  name: 'VisitorStep1',
  components: {
    Checkbox,
    InputIndex
  },
  data () {
    return {
      hasFormSubmitted: false,
      visitorForm: {
        input: {
          name: {
            value: ''
          },
          email: {
            value: ''
          },
          password: {
            value: ''
          },
          phone: {
            value: ''
          },
          occupation: {
            value: ''
          }
        },
        checkbox: {
          agreement: {
            value: false
          },
          agreePolicy: {
            value: false
          }
        }
      },
      error: '',
      busy: false
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'currentBuilding',
      'property'
    ]),
    formError () {
      return {
        nameRequired: !this.visitorForm.input.name.value,
        emailRequired: !this.visitorForm.input.email.value,
        passwordRequired: !this.visitorForm.input.password.value,
        phoneRequired: !this.visitorForm.input.phone.value,
        emailFormatInvalid: !!validate(
          {
            from: this.visitorForm.input.email.value
          },
          {
            from: { email: true }
          }
        ),
        passwordFormatInvalid: !!validate(
          {
            from: this.visitorForm.input.password.value
          },
          {
            from: {
              length: {
                minimum: 6
              }
            }
          }
        ),
        // phoneFormatInvalid: !!validate(
        //   {
        //     phone: this.visitorForm.input.phone.value
        //   },
        //   {
        //     phone: {
        //       format: {
        //         pattern:
        //           '^[+]{0,1}[(]{0,1}[0-9]{2,4}[)]{0,1}[-\\s]{0,1}[0-9]{3,4}([-\\s]{0,1}[0-9]{3,4})?[-\\s]{0,1}[0-9]{3,4}$',
        //         flags: 'g'
        //       }
        //     }
        //   }
        // ),
        agreeLicenseRequired:
          !this.visitorForm.checkbox.agreement.value
      }
    },
    formHasError () {
      const formErrorKeys = Object.keys(this.formError)
      const mapFormErrors = formErrorKeys.map(key => this.formError[key])
      const formHasError = mapFormErrors.some(error => error)
      return formHasError
    },
    visitorWelcomeText () {
      let visitorWelcomeText = this.$t('welcomeToLiveTour')
      visitorWelcomeText = visitorWelcomeText.replace(
        /<strong>/g,
        '<strong class="visitor-strong">'
      )
      return visitorWelcomeText
    },
    visitorImage () {
      if (isIE()) {
        return handImage
      }
      return handWithAnimateImage
    },
    companyInfo () {
      return this.user.companyInfo || {}
    },
    visitorAgreement1 () {
      const termsClassName = this.companyInfo.terms
        ? 'visitor-checkbox-a'
        : 'visitor-checkbox-a-disable'
      const privacyClassName = this.companyInfo.privacy
        ? 'visitor-checkbox-a'
        : 'visitor-checkbox-a-disable'
      const termsTag = `
        <a class="${termsClassName}" href="${this.companyInfo.terms}" target="_blank">${this.$t('userTerms')}</a>
      `
      const privacyTag = `
        <a class="${privacyClassName}" href="${this.companyInfo.privacy}" target="_blank">${this.$t('privacyPolicy')}</a>
      `
      const visitorAgreement = this.$t('visitorAgreement1', {
        company: this.companyInfo.company || `[${this.$t('companyName')}]`,
        termsTag,
        privacyTag
      })
      return visitorAgreement
    },
    visitorAgreement2 () {
      const visitorAgreement = this.$t('visitorAgreement2', {
        email:
          this.companyInfo.email || `[${this.$t('company')}${this.$t('email')}]`,
        company: this.companyInfo.company || `[${this.$t('companyName')}]`
      })
      return visitorAgreement
    },
    redirectUrl () {
      const hasProperty = this.property && this.property.objectId
      if (hasProperty) return this.property.meta.viewerRedirectUrl || location.href
      return this.currentBuilding.meta.viewerRedirectUrl || location.href
    }
  },
  watch: {
  },
  methods: {
    ...mapActions('vrlounge', [
      'setCurrentModal'
    ]),
    onSubmit () {
      this.hasFormSubmitted = true
      this.$nextTick(() => {
        if (this.formHasError) {
          this.formOnError()
          return
        }
        this.handleSendVerifyEmail()
      })
    },
    formOnError () {
      if (this.$refs.scrollDiv) {
        // https://trello.com/c/VI2SE7NE
        this.$refs.scrollDiv.scrollTop = this.$refs.scrollDiv.scrollHeight
      }
    },
    login () {
      this.setCurrentModal(MODALS.login)
    },
    async handleSendVerifyEmail () {
      this.error = ''
      this.busy = true
      gaEvents.sendEvent(
        'Visitor',
        'visitorSendVerifyEmail',
        this.currentBuilding.objectId
      )
      const payload = {
        name: this.visitorForm.input.name.value,
        email: this.visitorForm.input.email.value,
        password: this.visitorForm.input.password.value,
        phone: this.visitorForm.input.phone.value,
        occupation: this.visitorForm.input.occupation.value,
        promotionMail: this.visitorForm.checkbox.agreePolicy.value,
        redirectUrl: this.redirectUrl
      }
      const response = await visitorApi.signup(payload)
      const userParsedEmail = payload.email.replace(/[@.#!$%^&*()]/gm, '')
      if (response.error) {
        this.error = response.error
      } else {
        this.sendVerifyEmailSuccessful(userParsedEmail, payload)
      }
      this.busy = false
    },
    sendVerifyEmailSuccessful (userParsedEmail, payload) {
      gaEvents.sendEvent(
        'Visitor',
        'visitorSendVerifyEmailSuccessful',
        this.currentBuilding.objectId
      )
      this.hasFormSubmitted = false
      this.$emit('callback', payload)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main';
@import '~css/common/extends';

.visitor-step-1 {
  $mb = 18px;
  position: relative;
  height: "calc(100% - %s)" % $mb;
  padding-top: 10px;
  margin-left: 32px;
  margin-right: 32px;
  margin-bottom: $mb;

  $mb-l = 25px;
  @media (min-width: $layout) {
    padding-top: 14px;
    height: "calc(100% - %s)" % $mb-l;
    margin-bottom: $mb-l;
  }

  $mb-l = 41px;
  @media (min-width: $response) {
    height: "calc(100% - %s)" % $mb-l;
    padding-top: 36px;
    margin-left: 84px;
    margin-right: 84px;
    margin-bottom: $mb-l;
  }
}

.visitor-step-1-theme {
  p, a {
    color: $visitor-text-color;
    text-shadow: none;
  }
  a {
    &:hover {
      cursor: pointer;
      color: #5d5d5d;
    }
  }
}

.visitor-step-1-inner {
  height: calc(100% - 45px);
  overflow-y: auto;
  overflow-x: hidden;
  // 不要混用 -webkit-overflow-scrolling: touch; 和 this.$refs.scrollDiv.scrollTop = this.$refs.scrollDiv.scrollHeight 否則 iPhone Chrome input 會有文字不見的問題

  @media (min-width: $response) {
    overflow: visible;
  }
}

.visitor-step-1-login {
  margin-top: 22px;
  margin-bottom: 10px;
  font-size: 0.875rem;
  text-align: right;

  @media (min-width: $layout) {
    margin-top: 34px;
  }
  @media (min-width: $response) {
    margin: 0 -40px 30px;
  }

  a {
    color: $pink-color;
    text-decoration: underline;
  }
}

.visitor-step-1-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media (min-width: $response) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
}

.visitor-step-1-header-text {
  font-size: 0.75rem;
  color: $pink-color;
  text-shadow: none;

  @media (min-width: $layout) {
    font-size: 1rem;
  }

  @media (min-width: $response) {
    font-size: 0.875rem;
  }
}

.visitor-step-1-header-img {
  width: 50px;
  height: 42px;
  margin: 0;
  transform: scale(1.25);

  @media (min-width: $layout) {
    width: 62px;
    height: 52px;
  }

  @media (min-width: $response) {
    width: 72px;
    height: 60px;
    margin: 10px 10px;
  }
}

.visitor-step-1-desc {
  margin: 6px 0 3px;
  font-size: 0.75rem;
  letter-spacing: .23px;
  text-align: justify;
  line-height: normal;
  height: 70px;

  @media (min-width: $layout) {
    font-size: 1rem;
    line-height: 1.25rem;
    letter-spacing: .31px;
  }

  @media (min-width: $response) {
    margin: 0;
    font-size: 0.875rem;
    line-height: 1.125rem;
    letter-spacing: 0.23px;
  }
}

$vlw-mb = 30px;
$vlw-mb-l = 26px;
.visitor-label-wrapper {
  position: relative;

  .visitor-input-error {
    position: absolute;
    margin-top: 2px;
  }
}

.visitor-label-blank {
  height: $vlw-mb;

  @media (min-width: $response) {
    height: $vlw-mb-l;
  }
}

.visitor-label {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: $visitor-input-color;
}

.visitor-input-error-wrapper {
  display: flex;
  align-items: center;
  height: 17px;
  color: #d0021b;
  text-shadow: none;

  .visitor-input-error-icon + .visitor-input-error {
    margin-left: 5px;

    @media (min-width: $layout) {
      margin-left: 4px;
    }

    @media (min-width: $response) {
      margin-left: 5px
    }
  }
}

.visitor-input-error-icon {
  margin: 2.5px;
  font-size: 0.875rem;

  @media (min-width: $layout) {
    font-size: 1rem;
  }

  @media (min-width: $response) {
    font-size: 0.875rem;
  }
}

.visitor-input-error {
  display: inline-block;
  font-size: 0.75rem;
  color: #d0021b;
  text-shadow: none;

  @media (min-width: $layout) {
    font-size: 0.875rem;
  }

  @media (min-width: $response) {
    font-size: 0.75rem;
  }
}

.visitor-input {
  height: 23px;
  font-size: 0.875rem;

  &::placeholder {
    color: rgba($visitor-text-color, 0.4);
  }

  @media (min-width: $layout) {
    font-size: 1.25rem;
    height: 29px;
  }

  @media (min-width: $response) {
    height: 25px;
    font-size: 0.875rem;
  }
}

.visitor-checkbox-wrapper {
  .visitor-checkbox {
    margin-bottom: 6px;
    .agreement-text{
      font-size: 12px;
    }

    @media (min-width: $layout) {
      margin-bottom: 12px;
    }

    @media (min-width: $response) {
      margin-bottom: 8px;
    }
  }
}

.visitor-checkbox {
  a, span {
    font-size: 0.75rem;
    color: $dark-gray;
    font-weight: 300;
    text-shadow: none;

    @media (min-width: $layout) {
      font-size: 0.75rem;
    }

    @media (min-width: $response) {
      font-size: 0.5rem;
    }
  }
}

.visitor-step-1-btn-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .visitor-input-error {
    margin-bottom: 5px;
  }
}

.visitor-step-1-btn {
  width: 100%;
  height: 30px;
  padding: 5px 0;
  border-radius: 15px;
  background-color: $black;
  font-size: 0.875rem;
  color: $white;

  &[disabled] {
    background: #CCC;
    cursor: default;
  }

  @media (min-width: $layout) {
    border-radius: 17px;
    font-size: 1.125rem;
    height: 34px;
  }

  @media (min-width: $response) {
    border-radius: 16px;
    font-size: 1rem;
    height: 32px;

    &:hover {
      background-color: #5d5d5d;
    }
  }
}
</style>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/addon/main';

.visitor-checkbox-a {
  color: $dark-gray;
  text-shadow: none;
  text-decoration: underline;
}

.visitor-checkbox-a-disable {
  color: $dark-gray;
  text-shadow: none;
  text-decoration: underline;
  pointer-events: none;
  cursor: default;
}

.visitor-strong {
  font-size: 1.25rem;

  @media (min-width: $layout) {
    font-size: 1.5rem;
  }

  @media (min-width: $response) {
    font-size: 1.25rem;
    font-weight: 600;
  }
}
</style>
